<div class="mfa-otp-input" role="group" [attr.aria-label]="ariaLabel() | translate">
  <!-- Decoy credentials so Safari / iCloud Password AutoFill does not attach to OTP boxes -->
  <div class="prs-autofill-decoy" aria-hidden="true">
    <input type="text" name="username" tabindex="-1" autocomplete="username" />
    <input type="password" name="password" tabindex="-1" autocomplete="current-password" />
  </div>
  <input
    *ngFor="let digit of digits; let i = index; trackBy: trackByIndex"
    #digitInput
    type="text"
    inputmode="numeric"
    pattern="[0-9]*"
    [attr.autocomplete]="i === 0 ? 'one-time-code' : 'off'"
    [attr.name]="'prs-otp-digit-' + i"
    maxlength="1"
    class="form-control mfa-otp-input__digit"
    data-lpignore="true"
    data-1p-ignore="true"
    data-bwignore="true"
    data-form-type="other"
    [value]="digit"
    [disabled]="isDisabled"
    [attr.aria-label]="(ariaLabel() | translate) + ' ' + (i + 1)"
    (input)="onInput(i, $event)"
    (keydown)="onKeydown(i, $event)"
    (paste)="onPaste($event)"
  />
</div>
